import React from "react"
import PropTypes from "prop-types"
import './containers/Base.css'
import './PixelConfiguration.css'

function base64UrlEncode(str) {
  return btoa(str)
    .replace(/\+/g, '-')
    .replace(/\//g, '_')
    .replace(/=+$/, '');
}

class PixelConfiguration extends React.Component {
  generateWebhookUrl = () => {
    return `${window.location.origin}/pixels/roll/u/${this.props.privateToken}`;
  }

  copyToClipboard = (webhookUrl) => {
    navigator.clipboard.writeText(webhookUrl);
  }

  render () {
    const webhookUrl = this.generateWebhookUrl();

    return (
      <div className="content">
        <div className='ContentBox'>
          <h1>Pixel Dice</h1>
          <div>
            <h3>Web Hook</h3>
            <div className="PixelConfiguration__inputGroup">
              <input
                type="text"
                value={webhookUrl}
                readOnly
                className="PixelConfiguration__input"
                style={{ width: `${webhookUrl.length + 2}ch` }}
              />
              <button
                onClick={() => this.copyToClipboard(webhookUrl)}
                className="PixelConfiguration__button"
                title="Copy to clipboard"
              >
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect>
                  <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"></path>
                </svg>
              </button>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

PixelConfiguration.propTypes = {
  userId: PropTypes.number.isRequired,
  privateToken: PropTypes.string.isRequired
}

export default PixelConfiguration